import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: 'console/app-js/shared/components/icon/icon.component.html'
})
export class IconComponent {
  @Input() iconName: string;
}
